module.exports = __webpack_public_path__ + "static/media/girl.18ff7b71.png";